import { z } from 'zod';
/** Identificador de documento de MongoDB, validado como cadena hexadecimal de 24. */
export const esquemaId = z.string().regex(/^[0-9a-fA-F]{24}$/, 'Identificador inválido');
export const esquemaPaginacion = z.object({
    pagina: z.coerce.number().int().min(1).default(1),
    porPagina: z.coerce.number().int().min(1).max(100).default(20),
});
/** Texto clinico libre: se recorta y se limita, nunca se acepta indefinido. */
export function esquemaTextoClinico(maximo) {
    return z.string().trim().max(maximo);
}
/**
 * Zona horaria IANA que el motor de JavaScript reconoce (FIND-038).
 *
 * Antes era texto libre: una zona mal escrita se guardaba y despues cada fecha
 * del consultorio se calculaba mal o lanzaba al formatear.
 */
export const esquemaZonaHoraria = z
    .string()
    .trim()
    .min(3)
    .max(60)
    .refine((zona) => {
    try {
        new Intl.DateTimeFormat('es-MX', { timeZone: zona });
        return true;
    }
    catch {
        return false;
    }
}, { message: 'Zona horaria desconocida. Use una zona IANA, p. ej. America/Mexico_City' });
/**
 * Minimo comun de un motivo (correccion, cancelacion, baja, retiro).
 *
 * Un motivo de un caracter no explica nada y deja el rastro vacio de hecho.
 * Uno solo para toda la API (FIND-046, FIND-049).
 */
export const MOTIVO_MINIMO = 5;
export const esquemaMotivo = z
    .string()
    .trim()
    .min(MOTIVO_MINIMO, `Escriba el motivo (al menos ${MOTIVO_MINIMO} caracteres)`)
    .max(300);
//# sourceMappingURL=comunes.js.map